import "./parametersLabel.css";

type Props = {
    label: string;
};

export const ParametersLabel = ({ label }: Props) => {
    return (
        <div className="parameters-label-container">
            <span>{label}</span>
        </div>
    );
};
